export default __webpack_public_path__ + "static/media/logo.1d510083.png";